export const productDevelopmentDashboardFr = {
  title: 'Développement produit',
  subtitle: 'Vue selon le rôle des données de base, validations, production et planification.',
  help: 'Ouvrir l’aide au développement produit',
  refresh: 'Actualiser le tableau de bord',
  generatedAt: 'Données au {{date}}',
  loading: {
    title: 'Chargement du tableau de bord produit',
    description: 'Les signaux actuels de workflow et de planification sont calculés.',
  },
  error: {
    title: 'Impossible de charger le tableau de bord',
    description: 'Le serveur n’a pas pu calculer les signaux actuels du développement produit.',
    retry: 'Réessayer',
  },
  empty: {
    title: 'Aucun indicateur disponible pour ce rôle',
    description: 'Votre rôle n’a actuellement aucun droit de lecture sur les domaines du tableau.',
  },
  cards: {
    OPEN_WORKFLOWS: {
      title: 'Contrôles et validations ouverts',
      description: 'Éléments nécessitant une décision professionnelle explicite.',
    },
    INCOMPLETE_MATERIALS: {
      title: 'Matières premières incomplètes',
      description: 'Derniers profils sans validation, fournisseur ou noms de déclaration.',
    },
    DECLARATION_WARNINGS: {
      title: 'Avertissements de déclaration',
      description: 'Dernières déclarations avec erreurs, écarts ou langues manquantes.',
    },
    EXPIRING_VERSIONS: {
      title: 'Versions arrivant à échéance',
      description: 'Versions sources validées expirant dans les 30 jours.',
    },
    UPCOMING_PRODUCTION_ORDERS: {
      title: 'Ordres de production à venir',
      description: 'Ordres planifiés ou libérés démarrant dans les 14 jours.',
    },
    MATERIAL_SHORTAGES: {
      title: 'Manques de matières',
      description: 'Propositions ouvertes du dernier calcul MRP reproductible.',
    },
    PRODUCTION_DEVIATIONS: {
      title: 'Écarts de production',
      description: 'Dernières déclarations de fin avec écart exact de rendement ou consommation.',
    },
  },
  workflows: {
    title: 'Contrôles et validations',
    subtitle:
      'Seules les files correspondant aux actions autorisées pour votre rôle sont affichées.',
    review: 'Contrôle',
    approval: 'Validation',
    open: 'Ouvrir la file',
    none: 'Aucune file d’action n’est attribuée à votre rôle.',
  },
  queues: {
    MATERIALS: 'Profils matière',
    RECIPES: 'Recettes et nomenclatures',
    PROCESS_ROUTINGS: 'Gammes opératoires',
    DECLARATIONS: 'Déclarations',
    ANALYSIS: 'Profils d’analyse',
    SPECIFICATIONS: 'Spécifications produit',
    LABELS: 'Modèles d’étiquette',
    CHANGE_REQUESTS: 'Demandes de modification',
  },
  recentRecipes: {
    title: 'Recettes récemment modifiées',
    subtitle: 'Dernière version modifiée de chaque recette visible pour votre rôle.',
    empty: 'Aucune version de recette n’est disponible.',
    number: 'Numéro',
    name: 'Recette',
    product: 'Produit de sortie',
    version: 'Version',
    status: 'Statut',
    changed: 'Modifiée',
    open: 'Ouvrir la recette {{number}}',
  },
  deviations: {
    title: 'Écarts de rendement et de consommation',
    subtitle: 'Fins récentes ; les pourcentages sont calculés exactement côté serveur.',
    empty: 'Aucun écart n’a été enregistré sur la période actuelle de 30 jours.',
    order: 'Ordre',
    product: 'Produit',
    plannedActual: 'Prévu / réel',
    yield: 'Écart de sortie',
    material: 'Plus grand écart matière',
    reported: 'Déclaré',
    unbounded: 'Non borné (consommation avec prévision nulle)',
    open: 'Ouvrir l’ordre de production {{number}}',
  },
  recipeStatuses: {
    DRAFT: 'Brouillon',
    IN_REVIEW: 'En contrôle',
    APPROVED: 'Validée',
    BLOCKED: 'Bloquée',
    ARCHIVED: 'Archivée',
  },
} as const;
